import { gql } from 'graphql-request'
import { useQuery } from 'react-query'
import graphQLRequest from '../config/graphQLRequest'

const QUERYNAME = 'CANDIDATE/FEATURE_FLAGS'

const SIXTYMINS = 60 * (60 * 1000)
const SIXTYFIVEMINS = 65 * (60 * 1000)

const FETCH_FEATURE_FLAG_DATA = gql`
  query candidateFeatureFlags {
    currentUserEnabledFeatures
  }
`

const getFeatureFlags = () => {
  return graphQLRequest(FETCH_FEATURE_FLAG_DATA)
}

export default function useFeatureFlags() {
  const { data, error, isLoading, isSuccess } = useQuery([QUERYNAME], () => getFeatureFlags(), {
    staleTime: SIXTYMINS,
    cacheTime: SIXTYFIVEMINS,
    refetchOnWindowFocus: false,
    select: response => {
      const { currentUserEnabledFeatures = [] } = response
      return currentUserEnabledFeatures
    },
  })

  return { data, error, isLoading, isSuccess }
}
